<span class="th-content">
  <ng-content />
  <svg class="sort-icon" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.875 10H3.125V2.5H5L2.5 0L0 2.5H1.875V10ZM10 7.5H8.125V0H6.875V7.5H5L7.5 10L10 7.5Z" />
  </svg>
</span>
